module.exports = __webpack_public_path__ + "img/image-6-v1.0262b434.png";